import * as Sentry from '@sentry/browser';

export const sentrySetLoggedInContext = (userId: string, merchantId: string) => {
	setUser(userId);
	setMerchantId(merchantId);
};

export const setUser = (userId: string) => {
	Sentry.setUser({ id: userId });
};

export const setMerchantId = (merchantId: string) => {
	Sentry.setTag('merchantId', merchantId);
};
